import { Injectable } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '../services/user/user.service';

@Injectable({
  providedIn: 'root',
})
export class TokenGuard {
  constructor(private userService: UserService, private router: Router) {}

  canActivate: CanActivateFn = async () => {
    const token = await this.userService.ensureValidSession();
    if (token) {
      return true;
    } else {
      this.userService.logout();
      this.router.navigate(['/login']);
      return false;
    }
  };
}
